/**
 * Français.
 *
 * Les clés viennent de `cs.js`. Si l’une manque, le texte anglais s’affiche
 * (et à défaut le tchèque), pour qu’un trou se remarque.
 *
 * Traduction pas encore relue par une personne trans francophone. Le
 * vocabulaire de la transition et les accords de genre comptent ici plus
 * qu’ailleurs : si quelque chose sonne faux, dis-le et nous le changerons.
 */
const fr = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Retour',
  'obecne.hledat': 'Rechercher',
  'obecne.nacitani': 'Chargement…',
  'obecne.zrusit': 'Annuler',
  'obecne.ulozit': 'Enregistrer',
  'obecne.odeslat': 'Envoyer',
  'obecne.vice': 'Tout afficher',
  'obecne.jazyk': 'Langue',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Un espace sûr pour la communauté trans, où tu peux parler librement, chercher de l’aide et sentir le soutien des autres.',
  'auth.prihlaseni': 'Connexion',
  'auth.registrace': 'Inscription',
  'auth.email': 'E-mail',
  'auth.heslo': 'Mot de passe',
  'auth.emailPriklad': 'toi@exemple.fr',
  'auth.prihlasitSe': 'Se connecter',
  'auth.prihlasuji': 'Connexion en cours…',
  'auth.zapomenuteHeslo': 'Mot de passe oublié ?',
  'auth.presGoogle': 'Se connecter avec Google',
  'auth.spatneUdaje': 'E-mail ou mot de passe incorrect',
  'auth.uspech': 'Connexion réussie.',
  'auth.googleChyba': 'La connexion avec Google a échoué',
  'auth.obnoveniHesla': 'Réinitialisation du mot de passe',
  'auth.obnoveniOdeslano': 'Si l’adresse est enregistrée, tu recevras un lien pour réinitialiser ton mot de passe.',
  'auth.zpetNaPrihlaseni': 'Retour à la connexion',
  'auth.odeslatOdkaz': 'Envoyer le lien',
  'auth.obnoveniChyba': 'L’e-mail n’a pas pu être envoyé. Réessaie.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Encore une étape : ton code',
  'auth.jesteKodPopis': 'Ouvre ton application d’authentification et recopie les six chiffres affichés pour Bloom.',
  'auth.kod': 'Code',
  'auth.zalozniKodNapoveda': 'Pas de téléphone sous la main ? Saisis l’un des codes de secours que tu as gardés à l’activation.',
  'auth.potvrdit': 'Confirmer',
  'auth.overuji': 'Vérification…',
  'auth.kodNesedi': 'Ce code n’est pas le bon',
  'auth.zalozniDochazeji': (p) => `Il ne te reste que ${p.pocet} codes de secours. Génères-en de nouveaux dans ton profil.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Installer Bloom sur ton téléphone',
  'auth.krokyAndroid': [
      'Ouvre cette page dans Chrome',
      'Touche l’icône aux trois points (⋮) en haut à droite',
      'Choisis « Ajouter à l’écran d’accueil » ou « Installer l’application »',
      'Confirme l’installation',
    ],
  'auth.krokyIos': [
      'Ouvre cette page dans Safari',
      'Touche l’icône de partage (□↑) dans la barre du bas',
      'Descends et choisis « Sur l’écran d’accueil »',
      'Confirme en touchant « Ajouter »',
    ],
  'auth.seznamChranene': [
      { silne: 'Rien des membres n’est public.', text: 'Les profils, les récits, les offres, les questions, les photos et les avatars ne sont montrés qu’aux personnes connectées. Rien de tout cela ne peut être téléchargé ou collecté sans compte.' },
      { silne: 'Personne ne connaît ton mot de passe', text: '— nous non plus. Il est conservé sous forme d’empreinte bcrypt, dont on ne peut pas retrouver l’original.' },
      { silne: 'Les messages privés et les pièces jointes sont chiffrés', text: '(AES + contrôle d’intégrité) déjà sur le disque du serveur. Qui obtiendrait une sauvegarde ou le disque ne lirait que des caractères sans signification.' },
      { silne: 'Les messages s’effacent d’eux-mêmes', text: 'au bout d’un certain temps (90 jours par défaut), y compris les messages vocaux et les photos. Ce qui n’est plus là ne peut pas fuiter.' },
      { silne: 'Ton étape de transition est privée', text: 'tant que tu ne la publies pas. Personne d’autre ne voit les étapes que tu coches dans le Guide.' },
      { silne: 'L’e-mail et le téléphone', text: 'ne sont jamais montrés aux autres membres.' },
      { silne: '', text: 'La connexion est protégée contre les tentatives de deviner le mot de passe : le nombre d’essais est limité.' },
      { silne: 'Chiffrement de bout en bout des messages.', text: 'Quand tu l’actives, le texte et les pièces jointes sont chiffrés dans ton propre navigateur et le serveur ne reçoit que des caractères illisibles. La clé s’ouvre avec ton mot de passe et ne quitte jamais ton appareil : nous ne pouvons donc pas lire le contenu non plus, même si un tribunal le demandait. Le prix à payer : si tu oublies ton mot de passe, tu ne pourras plus lire tes anciens messages non plus.' },
      { silne: '', text: 'La session ne reste pas ouverte : Bloom te déconnecte à la fermeture de la fenêtre et après dix minutes d’inactivité.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Les métadonnées', text: '— qui écrit à qui et quand — le serveur doit les connaître pour livrer le message. Le chiffrement de bout en bout ne les cache pas, et Signal non plus.' },
      { silne: '', text: 'Bloom est une application web : elle télécharge son code de chiffrement depuis notre serveur à chaque ouverture. Qui prendrait le contrôle du serveur pourrait en théorie servir un code modifié. Seule une application signée venant d’un magasin protège de cela — c’est pour ça que Signal en a une et qu’une version web n’en a pas.' },
      { silne: 'Les profils', text: '— pseudo, description, avatar — ne peuvent pas être chiffrés, parce que le serveur doit les montrer aux autres membres.' },
      { silne: '', text: 'Les messages antérieurs à l’activation du chiffrement restent chiffrés uniquement sur le disque du serveur, pas de bout en bout.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom fonctionne comme une application, même hors connexion. Tes données sont toujours à jour.',
  'auth.zabezpeceniTitulek': 'Comment Bloom est sécurisé',
  'auth.zabezpeceniUvod': 'Bloom est un espace pour la communauté trans : des choses sensibles s’y croisent. Voici ce que '
      + 'nous faisons pour les protéger — et ce que nous ne savons pas faire — sans enjoliver.',
  'auth.coJeChranene': 'Ce qui est protégé',
  'auth.coNeumime': 'Ce que Bloom ne sait pas faire — et il est honnête de le dire',
  'auth.zabezpeceniZaver': 'Si tu as une question sur la confidentialité ou si tu as trouvé une faille, utilise « Signaler un problème » ci-dessous. Nous le prenons au sérieux.',
  'auth.mvp': 'Bloom en est à sa première version et nous l’améliorons avec la communauté. '
      + 'Si tu tombes sur un bug ou si tu as une idée, ça nous fera plaisir de le savoir.',
  'auth.nahlasitProblem': 'Signaler un problème',
  'auth.clenu': (p) => (p.pocet === 1 ? 'membre' : 'membres'),
  'auth.prispevku': (p) => (p.pocet === 1 ? 'publication' : 'publications'),
  'auth.odborniku': (p) => (p.pocet === 1 ? 'professionnel·le' : 'professionnel·les'),
  'auth.nabidek': (p) => (p.pocet === 1 ? 'offre' : 'offres'),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Pseudo (unique)',
  'reg.prezdivkaPriklad': 'Au moins 3 caractères',
  'reg.telefon': 'Téléphone',
  'reg.volitelne': '(facultatif)',
  'reg.heslo': 'Mot de passe',
  'reg.hesloZnovu': 'Répète le mot de passe',
  'reg.zajmeno': 'Pronoms',
  'reg.oMne': 'À propos de moi',
  'reg.oMnePriklad': 'Quelques mots sur toi…',
  'reg.registrovat': 'Créer un compte',
  'reg.registruji': 'Création du compte…',
  'reg.presGoogle': 'S’inscrire avec Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'Ou envoie ta propre photo',
  'reg.nahratFoto': 'Envoyer une photo',
  'reg.vlastni': 'Personnalisé',
  'reg.zeme': 'Pays',
  'reg.kraj': 'Région',
  'reg.nechciUvadet': 'Je préfère ne pas le dire',
  'reg.cesko': 'Tchéquie',
  'reg.svet': 'Reste du monde',

  // skupiny avatarů
  'reg.avatarFem': 'Féminins',
  'reg.avatarMask': 'Masculins',
  'reg.avatarNeutr': 'Neutres',
  'reg.avatarZvirata': 'Animaux',

  // komunitní heslo
  'reg.komunitniHeslo': 'Mot de passe de la communauté',
  'reg.komunitniHesloPriklad': 'Saisis le mot de passe de la communauté…',
  'reg.komunitniHesloPopis': 'Bloom est un espace privé pour la communauté trans. Quelqu’un de la communauté peut te donner le mot de passe.',
  'reg.napisAdminovi': 'Si tu ne connais personne, écris à l’administration à',
  'reg.nevimHeslo': 'Je ne connais pas le mot de passe de la communauté',
  'reg.jakZiskat': 'Le mot de passe de la communauté protège cet espace privé. Comment l’obtenir :',
  'reg.krok1': '1. Écris un e-mail à',
  'reg.krok2': '2. Présente-toi brièvement et dis comment tu as connu Bloom',
  'reg.krok3': '3. L’administration te répondra dès que possible',

  // kontrola hesla
  'reg.hesloKratke': 'Le mot de passe doit faire au moins 8 caractères',
  'reg.hesloMale': 'Le mot de passe doit contenir une minuscule',
  'reg.hesloVelke': 'Le mot de passe doit contenir une majuscule',
  'reg.hesloCislo': 'Le mot de passe doit contenir un chiffre',
  'reg.hesloZnak': 'Le mot de passe doit contenir un caractère spécial (!@#$%…)',
  'reg.pozadavek8': 'Au moins 8 caractères',
  'reg.pozadavekVelke': 'Une majuscule',
  'reg.pozadavekCislo': 'Un chiffre',
  'reg.pozadavekZnak': 'Un caractère spécial (!@#$%)',
  'reg.hesloNesouhlasi': 'Les mots de passe ne correspondent pas',
  'reg.prezdivkaKratka': 'Le pseudo doit faire au moins 3 caractères',
  'reg.hesloPovinne': 'Le mot de passe de la communauté est obligatoire',
  'reg.hotovo': 'Compte créé. Va vérifier ta boîte mail pour le confirmer.',
  'reg.fotoVelka': 'L’image est trop lourde (2 Mo maximum)',
  'reg.chyba': 'La création du compte a échoué',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Ici, personne n’a besoin d’être parfait. Bloom est un espace où chacun·e peut être qui iel est — '
      + 'où tu peux partager ton expérience, poser des questions et aider les autres. Sans jugement et sans préjugés.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · traduit du tchèque',
  'domu.vitej': 'Bonjour,',
  'domu.vCislech': 'Bloom en chiffres',
  'domu.noveVKomunite': 'Tu arrives ?',
  'domu.noveVKomunitePopis1': 'Tu n’as pas à te montrer. Tu n’as pas besoin de photo. Tu n’as pas à être out.',
  'domu.noveVKomunitePopis2': 'Bloom est un espace où tu peux commencer à ton rythme.',
  'domu.rozcestnik1': 'C’est ma première fois ici',
  'domu.rozcestnik2': 'Je ne sais pas par où commencer',
  'domu.rozcestnik3': 'Je veux rester anonyme',
  'domu.rozcestnik4': 'Je cherche des professionnel·les',
  'domu.rozcestnik5': 'Je veux juste lire des expériences',
  'domu.otazky': 'Des questions ou envie d’en savoir plus ? Écris-nous à',
  'domu.doporucujeme': 'À découvrir',
  'domu.odbornici': 'Professionnel·les',
  'domu.noviClenove': 'Nouvelles personnes dans la communauté',
  'domu.zadniNovi': 'Personne de nouveau pour l’instant',
  'domu.nejnovejsiOtazky': 'Dernières questions',
  'domu.zadneOtazky': 'Pas encore de questions.',
  'domu.nejlepeHodnoceni': 'Professionnel·les les mieux noté·es',
  'domu.zadniHodnoceni': 'Pas encore d’avis',
  'domu.zadneAktuality': 'Pas encore d’actualités',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Propose ce que tu sais faire et reçois l’aide des autres.',
  'domu.dlazdice.specialists': 'Trouve des professionnel·les vérifié·es, de la psychologie à la chirurgie.',
  'domu.dlazdice.legal': 'Aide juridique, articles et réponses à tes questions.',
  'domu.dlazdice.nearby': 'Services et professionnel·les près de chez toi.',

  // počty
  'domu.pocetClenu': (p) => (p.pocet === 1 ? 'membre de la communauté' : 'membres de la communauté'),
  'domu.pocetZkusenosti': (p) => (p.pocet === 1 ? 'expérience partagée' : 'expériences partagées'),
  'domu.pocetOdborniku': (p) => (p.pocet === 1 ? 'professionnel·le vérifié·e' : 'professionnel·les vérifié·es'),
  'domu.pocetNabidek': (p) => (p.pocet === 1 ? 'offre d’entraide' : 'offres d’entraide'),

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Accueil',
  'nav.news': 'Actualités',
  'nav.stories': 'Expériences de la communauté',
  'nav.mapaSveta': 'Carte du monde',
  'nav.support': 'Entraide',
  'nav.specialists': 'Professionnel·les trans-friendly',
  'nav.legal': 'Aide juridique',
  'nav.pageants': 'Concours',
  'nav.nearby': 'Près de moi',
  'nav.hledat': 'Rechercher dans Bloom',
  'nav.hledatPlaceholder': 'Chercher des personnes, des professionnel·les, des articles…',
  'nav.zpravy': 'Messages',
  'nav.profil': 'Mon profil',
  'nav.mojeCesta': 'Mon parcours',
  'nav.administrace': 'Administration',
  'nav.odhlasit': 'Se déconnecter',
  'nav.vsechnyVysledky': (p) => `Voir tous les résultats pour « ${p.dotaz} »`,
  'nav.overEmail': 'Vérifie ton e-mail',
  'nav.menu': 'Menu',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom à travers le monde',
  'svet.podtitulek': 'Choisis un pays et regarde ce que la communauté y a rassemblé.',
  'svet.hledatZemi': 'Chercher un pays…',
  'svet.vsechnyZeme': 'Tous les pays',
  'svet.jenSObsahem': 'Seulement les pays avec du contenu',
  'svet.nicNenalezeno': 'Aucun pays ne correspond.',
  'svet.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entrée' : 'entrées'}`,
  'svet.prazdnaZeme': 'Rien pour l’instant',
  'svet.kontinent': 'Continent',
  'svet.celySvet': 'Monde entier',
  'svet.vse': 'Tout',
  'svet.zacniDomovem': 'Commence par choisir le pays où tu vis. Tu peux aussi le choisir dans la liste sous la carte.',
  'svet.zkoumej': 'Choisis un pays et regarde ce que Bloom y a. Tu peux te promener partout — '
      + 'cela ne change pas ton pays de résidence.',
  'svet.domov': 'Chez toi',
  'svet.zrusitDomov': 'Retirer le pays de résidence',
  'svet.nastavitDomov': 'Définir comme mon pays',
  'svet.zeSveta': 'Dans le monde',
  'svet.coSeChysta': 'À venir',
  'svet.souteze': 'Concours aux inscriptions ouvertes',
  'svet.noveOrganizace': 'Nouvelles associations',
  'svet.kdeJizNeco': 'Là où Bloom a déjà quelque chose',
  'svet.hledatZemiPopisek': 'Chercher un pays',
  'svet.nicNeodpovida': 'Rien ne correspond. Essaie une autre recherche.',
  'svet.napovedaKMape': 'Fais glisser la carte pour la déplacer et zoome avec la molette ou les boutons. Tu n’es pas '
      + 'obligé·e de t’en servir : la recherche et la liste complète des pays sont en dessous.',
  'svet.tvujBloom': (p) => `Ton Bloom en ${p.zeme}`,
  'svet.tvojeDomovska': 'ton pays de résidence',
  'svet.zemi': (p) => `${p.pocet} ${p.pocet === 1 ? 'pays' : 'pays'}`,
  'svet.chyba': 'Les pays n’ont pas pu être chargés. Recharge la page.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${p.pocet === 1 ? 'professionnel·le' : 'professionnel·les'}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${p.pocet === 1 ? 'association' : 'associations'}`,
  'svet.pocet.events': (p) => `${p.pocet} ${p.pocet === 1 ? 'événement' : 'événements'}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${p.pocet === 1 ? 'concours' : 'concours'}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${p.pocet === 1 ? 'ressource' : 'ressources'}`,

  // světadíly
  'kontinent.europe': 'Europe',
  'kontinent.asia': 'Asie',
  'kontinent.africa': 'Afrique',
  'kontinent.north_america': 'Amérique du Nord',
  'kontinent.south_america': 'Amérique du Sud',
  'kontinent.oceania': 'Océanie',
  'kontinent.antarctica': 'Antarctique',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Concours trans du monde entier. Ceux où tu peux encore t’inscrire sont en haut.',
  'souteze.hledat': 'Chercher un concours…',
  'souteze.zadne': 'Nous n’avons pas encore de concours. Tu en connais un ? Envoie une suggestion.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Ouvrir : ${p.zeme}`,
  'nahled.zavrit': 'Fermer l’aperçu',
  'nahled.jenInformace': 'Pour l’instant nous n’avons que des informations sur le pays.',
  'nahled.zatimNic': 'Nous n’avons encore ici ni contacts, ni associations, ni événements. Tu connais quelque chose ? Envoie une suggestion.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom en ${p.zeme}`,
  'zeme.podtitulek': (p) => `Ce que la communauté a rassemblé en ${p.zeme}.`,
  'zeme.prazdna': 'Bloom commence tout juste ici. Tu pourrais être la première personne à y ajouter quelque chose.',
  'zeme.mapaSveta': 'Carte du monde',
  'zeme.navrhnout': 'Proposer une entrée',
  'zeme.domovska': 'Ton pays de résidence',
  'zeme.nastavitDomovskou': 'Définir comme mon pays',
  'zeme.kdeToJe': 'Où le trouver',
  'zeme.coTuBude': 'Ce que tu trouveras ici',
  'zeme.zatimPrazdne': 'vide pour l’instant',
  'zeme.pripravujeme': 'en préparation',
  'zeme.zobrazitVse': (p) => `Tout afficher (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom commence tout juste à grandir ici',
  'zeme.rostePopis': 'Nous n’avons encore rien ici. Tu connais une association, un événement ou un '
      + 'contact utile ? Envoie une suggestion : elle passe par une relecture, puis apparaît ici.',
  'zeme.jinouZemi': 'Parcourir d’autres pays',
  'zeme.bezKontaktu': 'Nous n’avons encore ici ni contacts ni associations.',
  'zeme.bezKontaktuPopis': 'Tu connais quelqu’un ou quelque chose d’utile ici ? Envoie une suggestion : '
      + 'elle passe par une relecture, puis apparaît ici.',
  'zeme.neznama': 'Nous ne connaissons pas ce pays.',
  'zeme.chyba': 'Le pays n’a pas pu être chargé.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Cabinets et cliniques',
  'sekce.specialists.popis': 'Médecins, cliniques et autres professionnel·les dont la communauté a l’expérience.',
  'sekce.organizations': 'Associations',
  'sekce.organizations.popis': 'Associations, structures à but non lucratif et groupes de soutien.',
  'sekce.events': 'Événements',
  'sekce.events.popis': 'Rencontres, Pride, ateliers et colloques.',
  'sekce.pageants': 'Concours',
  'sekce.pageants.popis': 'Concours trans et leurs dates.',
  'sekce.resources': 'Ressources',
  'sekce.resources.popis': 'Informations pratiques sur ce pays.',
  'sekce.community': 'Communauté',
  'sekce.community.popis': 'Personnes et groupes dans ce pays.',
  'sekce.legal': 'Aide juridique',
  'sekce.legal.popis': 'Informations et soutien pour la communauté trans',
  'sekce.support': 'Entraide',
  'sekce.support.popis': 'Propose ce que tu sais faire et reçois l’aide des autres membres',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Chercher dans ce pays…',
  'vypis.vsechnyKategorie': 'Toutes les catégories',
  'vypis.kategorie': 'Catégorie',
  'vypis.celaZeme': 'Tout le pays',
  'vypis.navrhnout': 'Proposer',
  'vypis.nicNeodpovida': 'Rien ne correspond. Essaie une autre recherche ou enlève le filtre.',
  'vypis.zadneZaznamy': (p) => `Nous n’avons pas encore d’entrées en ${p.zeme}.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entrée' : 'entrées'}`,
  'vypis.predchozi': 'Précédent',
  'vypis.dalsi': 'Suivant',
  'vypis.chyba': 'Les entrées n’ont pas pu être chargées.',
  'vypis.neznamyDruh': 'Nous ne connaissons pas ce type d’entrée.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Retour : ${p.zeme}`,
  'detail.kontakty': 'Contacts et liens',
  'detail.podrobnosti': 'Détails',
  'detail.zacatek': 'Début',
  'detail.termin': 'Date',
  'detail.uzaverka': 'Clôture des inscriptions',
  'detail.prihlaska': 'Inscription',
  'detail.strankaAkce': 'Page de l’événement',
  'detail.web': 'Site web',
  'detail.konec': 'Fin',
  'detail.stavRocniku': 'État de l’édition',
  'detail.oblasti': 'Domaines d’action',
  'detail.coNabizi': 'Ce qu’iels proposent',
  'detail.kategorie': 'Catégories',
  'detail.jazyky': 'Langues',
  'detail.vitezove': 'Précédentes gagnantes',
  'detail.kdoSeMuze': 'Qui peut participer',
  'detail.poradatel': 'Organisation',
  'detail.poplatek': 'Frais',
  'detail.tema': 'Thème',
  'detail.forma.offline': 'En présentiel',
  'detail.forma.online': 'En ligne',
  'detail.forma.hybrid': 'En présentiel et en ligne',
  'detail.rozsah.local': 'Local',
  'detail.rozsah.national': 'National',
  'detail.rozsah.international': 'International',
  'detail.rocnik.upcoming': 'À venir',
  'detail.rocnik.registration_open': 'Inscriptions ouvertes',
  'detail.rocnik.registration_closed': 'Inscriptions closes',
  'detail.rocnik.completed': 'Terminé',
  'detail.zdroj': (p) => `Source : ${p.zdroj}`,
  'detail.upraveno': (p) => `Dernière mise à jour : ${p.datum}`,
  'detail.overeno': 'Vérifié comme exact. Ce n’est pas une recommandation de Bloom.',
  'detail.neovereno': 'Cette entrée n’est pas encore vérifiée. Les informations ont pu changer : vérifie à la source.',
  'detail.nenalezen': 'Nous ne connaissons pas cette entrée. Elle a peut-être été supprimée, ou elle attend encore une relecture.',
  'detail.chyba': 'L’entrée n’a pas pu être chargée.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Ce qui s’applique ici',
  'profil.name_change': 'Changement de prénom',
  'profil.gender_marker': 'Changement de la mention de sexe',
  'profil.surgery_required': 'Chirurgie exigée',
  'profil.healthcare': 'Accès aux soins',
  'profil.legal_protection': 'Protection contre les discriminations',
  'profil.safety': 'Sécurité',
  'profil.stav.yes': 'Oui',
  'profil.stav.limited': 'En partie',
  'profil.stav.no': 'Non',
  'profil.stav.unknown': 'Sans information',
  'profil.zdroj': 'Source',
  'profil.zdrojZRoku': (p) => `source de ${p.rok}`,
  'profil.overeno': (p) => `Vérifié le ${p.datum}`,
  'profil.zmena': 'Changement récent',
  'profil.odKdy': (p) => `en vigueur depuis le ${p.datum}`,
  'profil.doklady': 'Sources',
  'profil.zakon': 'loi ou décision de justice',
  'profil.upozorneni': 'Ceci n’est pas un conseil juridique. Les lois changent et beaucoup dépend de ta '
      + 'situation précise : vérifie à la source ou auprès d’une association de ce '
      + 'pays avant d’agir.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Proposer ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Ta suggestion passe par une relecture avant d’apparaître dans Bloom. Remplis ce que '
      + 'tu sais — nous compléterons le reste.',
  'navrh.jednotne.organizations': 'une association',
  'navrh.jednotne.events': 'un événement',
  'navrh.jednotne.pageants': 'un concours',
  'navrh.jednotne.resources': 'une ressource',
  'navrh.popis.organizations': 'Une association, une structure à but non lucratif ou un groupe de soutien.',
  'navrh.popis.events': 'Une rencontre, une Pride, un atelier, un colloque.',
  'navrh.popis.pageants': 'Un concours trans – date, inscription, organisation.',
  'navrh.popis.resources': 'Information pratique – santé, droit, papiers, contacts.',
  'navrh.nazev': 'Nom',
  'navrh.popisPole': 'Description',
  'navrh.zeme': 'Pays',
  'navrh.mesto': 'Ville',
  'navrh.adresa': 'Adresse',
  'navrh.web': 'Site web',
  'navrh.email': 'E-mail',
  'navrh.telefon': 'Téléphone',
  'navrh.odkudVis': 'D’où le sais-tu',
  'navrh.odkudVisPriklad': 'p. ex. leur site, j’y étais…',
  'navrh.vyberte': '— choisis —',
  'navrh.forma': 'Format',
  'navrh.rozsah': 'Portée',
  'navrh.platiPro': 'S’applique à',
  'navrh.platnost.global': 'Le monde entier',
  'navrh.platnost.country': 'Un pays',
  'navrh.platnost.region': 'Une région',
  'navrh.platnost.city': 'Une ville',
  'navrh.odkazAkce': 'Lien vers l’événement',
  'navrh.odkazPrihlaska': 'Lien vers l’inscription',
  'navrh.odkazy': 'Liens',
  'navrh.text': 'Texte',
  'navrh.odeslat': 'Envoyer la suggestion',
  'navrh.odesilam': 'Envoi…',
  'navrh.chyba': 'La suggestion n’a pas pu être envoyée',
  'navrh.dikyTitulek': 'Merci, c’est noté',
  'navrh.dikyPopis': 'Nous avons bien reçu ta suggestion. Quelqu’un va la relire et elle apparaîtra '
      + 'ensuite dans Bloom. Rien n’est publié automatiquement.',
  'navrh.zavrit': 'Fermer',
  'navrh.seznamNapoveda': 'Sépare les éléments par des virgules.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `${p.druh} — c’est le tien ?`,
  'prevzeti.popis': 'Tu peux reprendre le profil et tenir les informations à jour. '
      + 'La demande passe d’abord par une relecture.',
  'prevzeti.tlacitko': 'Reprendre ce profil',
  'prevzeti.spravujes': 'Tu gères ce profil. Tu peux corriger les informations quand tu veux : les changements s’appliquent tout de suite.',
  'prevzeti.upravit': 'Modifier les informations',
  'prevzeti.spravujeSama': (p) => `Ce profil est géré directement par ${p.druh}.`,
  'prevzeti.ceka': 'Nous avons reçu ta demande et nous la relisons.',
  'prevzeti.formulacTitulek': (p) => `Reprendre le profil — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Avant de te confier le profil, nous devons savoir que tu fais bien partie de '
      + 'l’association. La demande passe par une relecture ; rien ne change tout de suite.',
  'prevzeti.role': 'Quel est ton rôle là-bas ?',
  'prevzeti.rolePriklad': 'p. ex. coordination, présidence de l’association',
  'prevzeti.doklad': 'Comment pouvons-nous le vérifier ?',
  'prevzeti.dokladPriklad': 'p. ex. je figure sur le site de l’association dans les contacts ; ou écris depuis une adresse officielle',
  'prevzeti.dokladNapoveda': 'Un lien vers une page où tu figures suffit, ou l’adresse officielle '
      + 'de l’association depuis laquelle écrire.',
  'prevzeti.kontakt': 'Ton contact',
  'prevzeti.kontaktPriklad': 'e-mail ou téléphone',
  'prevzeti.dalsi': 'Autre chose',
  'prevzeti.nepovinne': '(facultatif)',
  'prevzeti.odeslat': 'Envoyer la demande',
  'prevzeti.odesilam': 'Envoi…',
  'prevzeti.vyplnObe': 'Dis-nous quel est ton rôle et comment cela peut être vérifié.',
  'prevzeti.prijato': 'Merci. Nous avons reçu ta demande et nous te répondrons.',
  'prevzeti.chyba': 'La demande n’a pas pu être envoyée.',
  'prevzeti.upravaTitulek': (p) => `Modifier le profil — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Le nom et le lieu ne sont pas ici, et c’est voulu : les entrées sont cherchées et '
      + 'triées d’après eux. S’ils ont changé, écris-nous et nous les mettrons à jour.',
  'prevzeti.popisPole': 'Description',
  'prevzeti.email': 'E-mail',
  'prevzeti.telefon': 'Téléphone',
  'prevzeti.web': 'Site web',
  'prevzeti.ulozeno': 'Enregistré.',
  'prevzeti.ukladam': 'Enregistrement…',
  'prevzeti.chybaUlozeni': 'L’enregistrement a échoué.',
  'prevzeti.druh.organizations': 'l’association',
  'prevzeti.druh.events': 'l’événement',
  'prevzeti.druh.pageants': 'le concours',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Modifie tes informations et tes réglages',
  'profil.overeny': 'Vérifié',
  'profil.neovereny': 'Non vérifié',
  'profil.overteEmail': 'Vérifie ton e-mail. Un compte non vérifié a des droits limités.',
  'profil.emailOdeslan': 'E-mail de vérification envoyé.',
  'profil.emailChyba': 'L’e-mail n’a pas pu être envoyé',
  'profil.odeslano': 'Envoyé.',
  'profil.overeniOdbornika': 'Vérification comme professionnel·le ou juriste',
  'profil.pracujeteVOboru': 'Tu travailles dans le domaine ? Obtiens un badge vérifié.',
  'profil.zadostOdeslana': 'Demande envoyée',
  'profil.pozadatOOvereni': 'Demander la vérification',
  'profil.zadostTitulek': 'Demander la vérification comme professionnel·le ou juriste',
  'profil.zadostPopis': 'Remplis les informations de ta demande. La modération la relira.',
  'profil.pozadovanaRole': 'Rôle demandé',
  'profil.roleOdbornik': 'Professionnel·le',
  'profil.rolePravnik': 'Juriste',
  'profil.specializace': 'Spécialité',
  'profil.odkazNaProfil': 'Lien vers un profil professionnel',
  'profil.zpravaProAdmina': 'Un court message pour l’administration',
  'profil.odesilam': 'Envoi…',
  'profil.odeslatZadost': 'Envoyer la demande de vérification',
  'profil.vyplnteSpecializaci': 'Remplis ta spécialité',
  'profil.zadostUspech': 'Ta demande de vérification a été envoyée.',
  'profil.zadostChyba': 'La demande n’a pas pu être envoyée',

  // bezpečnost
  'bezp.titulek': 'Sécurité',
  'bezp.sifrovaniZapnuto': (p) => `Le chiffrement des messages est activé${p.odemceno ? ' et déverrouillé' : ' (verrouillé dans cet onglet)'}.`,
  'bezp.sifrovaniVypnuto': 'Tu n’as pas encore activé le chiffrement des messages.',
  'bezp.sifrovaniKde': 'Il s’active et se déverrouille sur la page Messages.',
  'bezp.sifrovaniKdeVypnute': 'Tu peux l’activer depuis la page Messages, dans n’importe quelle conversation.',
  'bezp.zmenaHesla': 'Changer de mot de passe',
  'bezp.zmenaHeslaSifrovani': 'Le chiffrement est activé : changer de mot de passe ré-enveloppe aussi la clé de tes messages. '
      + 'C’est pour ça que le mot de passe actuel est nécessaire — sans lui, la clé ne pourrait pas être ouverte et tu perdrais tes messages.',
  'bezp.stavajiciHeslo': 'Mot de passe actuel',
  'bezp.noveHeslo': 'Nouveau mot de passe',
  'bezp.noveHesloZnovu': 'Répète le nouveau mot de passe',
  'bezp.pozadavky': 'Au moins 8 caractères, des majuscules et des minuscules, un chiffre et un caractère spécial.',
  'bezp.zmenitHeslo': 'Changer le mot de passe',
  'bezp.menim': 'Changement…',
  'bezp.hesloNeshoda': 'Les nouveaux mots de passe ne correspondent pas.',
  'bezp.vyplnObe': 'Remplis les deux mots de passe.',
  'bezp.stareNesedi': 'Le mot de passe actuel n’est pas le bon — la clé de tes messages serait perdue, donc rien n’a été changé.',
  'bezp.zmenenoSKlicem': 'Mot de passe changé. La clé de tes messages a été ré-enveloppée : les anciens messages restent lisibles.',
  'bezp.zmeneno': 'Mot de passe changé.',
  'bezp.zmenaChyba': 'Le mot de passe n’a pas pu être changé.',
  'bezp.nepamatujes': 'Tu ne te souviens plus du mot de passe de la clé ?',
  'bezp.zahoditPopis': 'Tu peux jeter la clé et repartir de zéro. Les messages chiffrés jusqu’ici seront perdus définitivement '
      + '— personne ne peut les lire, nous non plus. Et c’est justement pour ça que c’est sûr.',
  'bezp.zahodit': 'Jeter les clés et repartir de zéro',
  'bezp.zahoditPotvrzeni': 'Vraiment jeter les clés ?\n\nTous les messages chiffrés jusqu’ici seront perdus définitivement '
      + '— personne ne peut les lire, nous non plus. Ne fais ça que si tu ne te souviens plus du mot de passe '
      + 'utilisé à l’activation du chiffrement.',
  'bezp.klicSmazan': 'Clés supprimées. Recharge la page.',
  'bezp.nepovedlo': 'Ça n’a pas marché.',
  'bezp.prohlizecNeumi': 'Ce navigateur ne prend pas en charge le chiffrement utilisé par Bloom.',

  'profil.mujProfil': 'Mon profil',
  'profil.specializacePriklad': 'p. ex. psychologie, sexologie, droit…',
  'profil.zpravaPriklad': 'Par exemple un lien vers ton inscription à l’ordre ou vers le site de ton cabinet…',
  'profil.overeniUvod': 'Tu veux être professionnel·le ou juriste vérifié·e sur Bloom ? Envoie une demande de vérification. '
      + 'Ton profil doit correspondre à ta vraie profession.',

  'profil.oborPriklad': 'p. ex. chirurgie plastique, droit de la famille…',
  'profil.nepovinnyText': 'Note complémentaire, facultative…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Double authentification',
  'dvf.zapnuto': (p) => `Activée. Il te reste ${p.pocet} codes de secours.`,
  'dvf.vypnuto': 'En plus de ton mot de passe, tu saisis un code à six chiffres donné par une application sur ton téléphone.',
  'dvf.chraniA': 'Elle protège',
  'dvf.chraniPrihlaseni': 'la connexion',
  'dvf.chraniB': ' : quelqu’un qui connaît ton mot de passe mais n’a pas ton téléphone ne peut pas entrer.',
  'dvf.nechrani': 'Elle ne protège pas les messages chiffrés',
  'dvf.nechraniPopis': ' — ceux-là s’ouvrent avec ton mot de passe dans ton propre navigateur, sans le serveur.',
  'dvf.ulozKody': 'Garde ces dix codes de secours',
  'dvf.ulozKodyPopis1': 'Chacun ne sert qu’une fois, et c’est le seul moyen d’entrer si tu perds ton téléphone.',
  'dvf.znovuNeukaze': 'Personne ne te les montrera à nouveau',
  'dvf.ulozKodyPopis2': ' — nous n’en gardons que l’empreinte.',
  'dvf.zkopirovat': 'Copier',
  'dvf.ulozilaJsem': 'Je les ai gardés',
  'dvf.zkopirovano': 'Copié.',
  'dvf.kopieChyba': 'La copie a échoué, note-les à la main.',
  'dvf.zapnout': 'Activer la double authentification',
  'dvf.pripravuji': 'Préparation…',
  'dvf.nactiKod': 'Scanne ce code dans une application d’authentification — par exemple Google Authenticator, Authy, 1Password ou Aegis.',
  'dvf.qrNejde': 'Impossible de scanner le QR code ?',
  'dvf.zadejRucne': 'Saisis cette clé à la main dans l’application :',
  'dvf.opisKod': 'Recopie le code affiché par l’application',
  'dvf.zapnoutKratce': 'Activer',
  'dvf.overuji': 'Vérification…',
  'dvf.noveKody': 'Nouveaux codes de secours',
  'dvf.vypnout': 'Désactiver',
  'dvf.noveKodyPopis': 'Le nouveau jeu remplace l’ancien : tes codes de secours actuels cesseront de fonctionner.',
  'dvf.kodZAplikace': 'Code de l’application',
  'dvf.vygenerovat': 'Générer',
  'dvf.vypnutiPopis': 'La désactivation demande ton mot de passe et un code valide. Les deux, volontairement : sinon n’importe qui ayant accès à un navigateur ouvert pourrait l’enlever.',
  'dvf.kodNeboZalozni': 'Code de l’application ou code de secours',
  'dvf.vypinam': 'Désactivation…',
  'dvf.vypnoutCele': 'Désactiver la double authentification',
  'dvf.vypnuto2': 'Double authentification désactivée.',
  'dvf.kodNesedi': 'Ce code n’est pas le bon.',
  'dvf.nepovedlo': 'Ça n’a pas marché.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Profil mis à jour.',
  'pf.chyba': 'Le profil n’a pas pu être mis à jour',
  'pf.fotkaNahrana': 'Photo envoyée.',
  'pf.fotkaChyba': 'L’image n’a pas pu être envoyée',
  'pf.fotkaVelka': 'L’image est trop lourde (5 Mo maximum)',
  'pf.oznameniUlozeno': 'Réglages de notifications enregistrés.',
  'pf.oznameniChyba': 'Les réglages n’ont pas pu être enregistrés',
  'pf.zruseno': 'Ton profil a été supprimé',
  'pf.zruseniChyba': 'Le profil n’a pas pu être supprimé',
  'pf.zruseniPotvrzeni': 'Veux-tu vraiment supprimer ton profil ? C’est irréversible et toutes tes données seront effacées.',
  'pf.urlFacebook': 'L’adresse Facebook doit commencer par https://',
  'pf.urlInstagram': 'L’adresse Instagram doit commencer par https://',
  'pf.urlLinkedin': 'L’adresse LinkedIn doit commencer par https://',
  'pf.ukladam': 'Enregistrement…',
  'pf.ulozitOznameni': 'Enregistrer les réglages de notifications',
  'pf.oznameniZpravy': 'Messages privés',
  'pf.oznameniAdmin': 'Nouveau message de l’administration',
  'pf.oznameniUzivatel': 'Nouveau message d’une autre personne',
  'pf.oznameniPodpora': 'Nouvelle publication dans Entraide',
  'pf.oznameniNabidky': 'Offres et demandes',

  // odznaky
  'pf.odznakAdmin': 'Administration',
  'pf.odznakPravnik': 'Juriste',
  'pf.odznakSpecialista': 'Professionnel·le vérifié·e',
  'pf.odznakClen': 'Membre vérifié·e de la communauté',
  'pf.odznakPomocnik': 'Aide active',
  'pf.odznakDuveryhodny': 'Personne de confiance',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Photo ajoutée à la galerie.',
  'gal.smazano': 'Photo supprimée',
  'gal.hesloKratke': 'Le mot de passe de la galerie doit faire au moins 4 caractères',
  'gal.nahraniChyba': 'La photo n’a pas pu être envoyée',
  'gal.mazaniChyba': 'La photo n’a pas pu être supprimée',
  'gal.souborVelky': 'Le fichier est trop lourd (5 Mo maximum)',
  'gal.ulozitNastaveni': 'Enregistrer les réglages',
  'gal.hesloPopis': 'Les personnes qui la visitent devront saisir ce mot de passe pour voir la galerie.',
  'gal.pridat': 'Ajouter une photo ou une vidéo',
  'gal.prazdna': 'Pas encore de photos dans la galerie',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Où en suis-je ?',
  'cesta.popis': 'Partage ton étape de transition si tu veux — ou garde-la pour toi.',
  'cesta.soukroma': 'Ton étape est privée',
  'cesta.viditelna': 'Ton étape est visible par les autres',
  'cesta.jenTy': 'Toi seul·e vois ton étape',
  'cesta.mohouNajit': 'Les autres peuvent te trouver via « Trouver des personnes à une étape proche »',
  'cesta.poznamka': 'Note personnelle',
  'cesta.volitelna': '(facultatif)',
  'cesta.poznamkaPriklad': 'Tout ce que tu veux partager ou garder en mémoire…',
  'cesta.najitPodobne': 'Trouver des personnes à une étape proche',
  'cesta.hledam': 'Recherche…',
  'cesta.ulozit': 'Enregistrer mon parcours',
  'cesta.ulozeno': 'Ton parcours a été enregistré.',
  'cesta.vyberteFazi': 'Choisis une étape',
  'cesta.chyba': 'L’enregistrement a échoué',

  'pf.socialniSite': 'Réseaux sociaux',
  'pf.avatarFoto': 'Avatar / photo de profil',
  'pf.nahratProfilni': 'Envoyer une photo de profil',
  'pf.zrusitProfil': 'Supprimer le profil',
  'pf.nastaveniOznameni': 'Réglages de notifications',
  'pf.nastaveniOznameniPopis': 'Choisis ce dont tu veux être averti·e.',
  'gal.overEmail': 'Pour envoyer des photos, il faut d’abord vérifier ton e-mail.',
  'cesta.coMeCeka': 'Ce qui m’attend',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Messages',
  'zpr.hledatUzivatele': 'Chercher une personne…',
  'zpr.zadneKonverzace': 'Pas encore de conversations',
  'zpr.vyhledejteVyse': 'Cherche une personne ci-dessus',
  'zpr.vyberteKonverzaci': 'Choisis une conversation ou cherche quelqu’un',
  'zpr.napisteZpravu': 'Écris un message…',
  'zpr.nahravam': 'Enregistrement…',
  'zpr.prilozitObrazek': 'Joindre une image',
  'zpr.hlasovaZprava': 'Message vocal',
  'zpr.zastavitNahravani': 'Arrêter l’enregistrement',
  'zpr.obrazek': 'Image',
  'zpr.overteEmail': 'Pour envoyer des messages, vérifie ton e-mail.',
  'zpr.profil': 'Profil',

  // šifrování
  'zpr.sifrovanaZprava': 'Message chiffré',
  'zpr.odemkniNahore': 'Message chiffré — déverrouille tes messages ci-dessus.',
  'gal.soukromiGalerie': 'Confidentialité de la galerie',
  'gal.verejnaGalerie': 'Galerie publique',
  'zpr.nelzeOtevrit': 'Ce message chiffré n’a pas pu être ouvert.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Personne introuvable',
  'zpr.prijemceNenalezen': 'Destinataire introuvable',
  'zpr.prihlasteZnovu': 'Reconnecte-toi (ta session a expiré)',
  'zpr.serverNedostupny': 'Le serveur est injoignable. Vérifie que le backend tourne.',
  'zpr.chybaOdeslani': 'L’envoi a échoué',
  'zpr.souborVelky': 'Le fichier est trop lourd (5 Mo maximum)',
  'zpr.formatNepodporovan': 'Type de fichier non pris en charge',
  'zpr.mediaOdeslano': 'Fichier envoyé',
  'zpr.mikrofon': 'Le micro n’est pas disponible',
  'zpr.hlasovkaOdeslana': 'Message vocal envoyé',
  'zpr.hlasovkaChyba': (p) => `L’envoi du message vocal a échoué : ${p.detail}`,
  'zpr.smazano': 'Conversation supprimée',
  'zpr.smazaniChyba': 'La conversation n’a pas pu être supprimée',
  'zpr.smazaniPotvrzeni': 'Elle disparaît de ta liste, pièces jointes comprises. L’autre personne garde sa copie : '
      + 'le message n’est entièrement effacé du serveur que lorsque vous l’avez supprimé toutes les deux.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Saisis ton mot de passe.',
  'sif.zapnuto': 'Le chiffrement est activé.',
  'sif.odemceno': 'Tes messages sont déverrouillés.',
  'sif.hesloNesedi': 'Ce mot de passe n’est pas le bon.',
  'sif.prohlizecNeumi': 'Ce navigateur ne prend pas en charge le chiffrement utilisé par Bloom. Tu peux quand même écrire, '
      + 'mais les messages ne seront pas chiffrés de bout en bout.',
  'sif.noveJsouSifrovane': 'Les nouveaux messages sont chiffrés. Tu es seul·e à avoir la clé : le serveur ne peut pas les lire.',
  'sif.odemkniZpravy': 'Déverrouille tes messages',
  'sif.odemkniPopis': 'La clé ne vit que dans la mémoire de cet onglet : après un rechargement, il faut de nouveau le mot de passe. '
      + 'Nous ne pouvons la garder nulle part — sinon ce ne serait plus un chiffrement que tu contrôles seul·e.',
  'sif.zapniSifrovani': 'Activer le chiffrement des messages',
  'sif.zapniPopis': 'Les nouveaux messages sont chiffrés ici même, sur ton appareil. Le serveur ne reçoit que des caractères illisibles '
      + 'et ne peut pas les lire — même si un tribunal les demandait.',
  'sif.pozorA': 'Attention : la clé s’ouvre avec ton mot de passe.',
  'sif.pozorTucne': 'Si tu l’oublies, personne ne pourra lire tes messages chiffrés',
  'sif.pozorB': ' — nous non plus. C’est tout l’intérêt, mais cela veut dire qu’il te faut un endroit où le garder.',
  'sif.mobilA': 'L’activer change aussi la façon dont tu te connectes : ton mot de passe n’arrive plus du tout au serveur, seule son empreinte est envoyée.',
  'sif.mobilTucne': 'L’ancienne application mobile Bloom ne pourra alors plus se connecter à ce compte',
  'sif.mobilB': ' tant que nous ne l’aurons pas mise à jour. Sur le web, tout continue de fonctionner.',
  'sif.zapnoutSifrovani': 'Activer le chiffrement',
  'sif.odemknout': 'Déverrouiller',
  'sif.tvojeHeslo': 'Ton mot de passe Bloom',
  'sif.prilohaZamcena': 'Pièce jointe chiffrée — déverrouille tes messages ci-dessus.',
  'sif.prilohaChyba': 'La pièce jointe n’a pas pu être ouverte.',
  'sif.priloha': 'Pièce jointe du message',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Ta localisation',
  'okoli.nastavtePolohu': 'Indique où tu es pour voir des résultats proches de toi',
  'okoli.vyberteVyse': 'Choisis un lieu ci-dessus pour voir les offres et les professionnel·les près de toi',
  'okoli.zadniOdbornici': 'Aucun·e professionnel·le n’est encore inscrit·e dans cette zone',
  'okoli.zadneNabidky': 'Il n’y a pas encore d’offres dans cette zone',
  'okoli.zadniClenove': 'Il n’y a encore personne de la communauté dans cette zone',
  'okoli.vytvoritNabidku': 'Créer une offre',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Recherche :',
  'hled.vysledkyPro': 'Résultats de la recherche :',
  'hled.nicPro': 'Nous n’avons rien trouvé pour :',
  'hled.nicZkuste': 'Nous n’avons rien trouvé. Essaie un autre mot.',
  'hled.zkratte': 'Essaie une expression plus courte ou un autre mot-clé.',
  'hled.zadejte': 'Écris ce que tu cherches et appuie sur Entrée',
  'hled.priklady': 'Par exemple : FFS, hormones, prénom, médecin, papiers, chirurgie…',
  'hled.uzivatele': 'Personnes',
  'hled.odbornici': 'Professionnel·les trans-friendly',
  'hled.clanky': 'Aide juridique – articles',
  'hled.otazky': 'Questions de la communauté',
  'hled.nabidky': 'Offres d’aide',
  'hled.prispevky': 'Publications',
  'hled.recenze': 'Avis sur les professionnel·les',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Personne introuvable',
  'up.oMne': 'À propos',
  'up.clenOd': 'Sur Bloom depuis',
  'up.odznakSpravce': 'Administration',
  'up.odznakPravnik': 'Juriste',
  'up.odznakOdbornik': 'Professionnel·le vérifié·e',
  'up.odznakPravnikOvereny': 'Juriste vérifié·e',
  'up.odznakClen': 'Membre vérifié·e',
  'up.odznakPomocnik': 'Aide active',
  'up.odznakDuveryhodny': 'De confiance',

  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Retour à Bloom',
  'kom.oProjektu': 'Bloom est né comme un espace communautaire sûr pour les personnes trans de Tchéquie — un endroit '
      + 'pour partager son expérience, trouver du soutien, rencontrer des professionnel·les et faire des connaissances. '
      + 'Le projet est porté bénévolement par la communauté. Ses buts : la discrétion, la confidentialité et l’entraide.',
  'kom.kontaktText': 'Une question, besoin d’aide ? Écris-nous. Nous essayons de répondre au plus vite.',
  'kom.respekt': 'Nous nous respectons',
  'kom.respektPopis': 'Nous appelons chaque personne par le prénom et les pronoms qu’elle utilise. Nous respectons les parcours et les expériences différents : '
      + 'il n’y a pas de bonne ou de mauvaise façon d’être trans.',
  'kom.soukromi': 'Nous protégeons la vie privée des autres',
  'kom.soukromiPopis': 'Ce qui se partage dans Bloom reste dans Bloom. Ne partage pas d’informations sur d’autres membres sans '
      + 'leur accord. Nous respectons l’anonymat.',
  'kom.pomahame': 'Nous nous entraidons',
  'kom.pomahamePopis': 'Bloom, c’est du soutien mutuel. Nous partageons nos expériences, nous nous aidons et nous construisons un espace sûr '
      + 'pour toute personne qui cherche du lien ou des informations.',
  'kom.obtezovani': 'Nous ne tolérons pas le harcèlement',
  'kom.obtezovaniPopis': 'Le harcèlement, les brimades ou les commentaires hostiles n’ont pas leur place dans Bloom. Si tu te sens mal à l’aise, '
      + 'écris à l’administration.',
  'kom.spam': 'Ni spam ni publicité',
  'kom.spamPopis': 'Bloom n’est pas une place de marché. Ne publie pas de publicité non sollicitée ni de contenu commercial. '
      + 'Les offres et les demandes vont dans Entraide.',
  'kom.prostor': 'Un espace pour chaque étape',
  'kom.prostorPopis': 'Tu n’es pas seul·e, où que tu en sois de ton parcours. Nous accueillons celles et ceux qui envisagent '
      + 'une transition, qui sont en plein dedans et qui l’ont derrière eux — et nous prenons chaque parcours tel qu’il est.',
  'kom.dataPopis': 'Bloom ne recueille que les données dont la plateforme a besoin pour fonctionner : ton e-mail, ton pseudo et le profil '
      + 'que tu crées toi-même.',
  'kom.dataTretiStrany': 'Tes données ne sont pas transmises à des tiers. La plateforme n’utilise aucune technologie de pistage ni régie publicitaire.',
  'kom.dataSmazani': 'Tu as le droit de demander la suppression de ton compte et de toutes les données liées. Écris à l’administration.',

  'okoli.podtitulek': 'Trouve des membres de la communauté, des services et des professionnel·les près de toi',
  'okoli.cleneVOkoli': (p) => `Membres de la communauté près de ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Offres d’aide près de ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Professionnel·les près de ${p.misto}`,
  'hled.zobrazitVice': 'Voir plus',
  'kom.titulek': 'Règles de la communauté',
  'kom.podtitulek': 'Un espace sûr pour tout le monde',
  'kom.jakNahlasit': 'Comment signaler un problème',
  'kom.jakNahlasitPopis': 'Si tu tombes sur un comportement déplacé, tu as deux possibilités : le bouton « Signaler cette personne » '
      + 'sur son profil, ou écrire à l’administration.',
  'kom.duverne': 'Ton signalement est confidentiel.',
  'kom.ochranaSoukromi': 'Confidentialité',
  'obecne.zpetKratce': 'Retour',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Personne d’autre dans la communauté ne partage encore publiquement cette étape.',
  'cesta.poznamkaFazePriklad': 'Tout ce que tu veux partager ou garder en mémoire sur cette étape…',
  'pruvodce.fazeNenalezena': 'Étape introuvable',
  'pruvodce.pripravujeme': 'Nous préparons encore cette partie.',
  'pruvodce.krokyJenTy': 'Les étapes que tu coches, toi seul·e les vois.',
  'pruvodce.nastavitFazi': 'Définir comme mon étape actuelle',
  'pruvodce.fazeNastavena': 'Définie comme ton étape actuelle',
  'pruvodce.chyba': 'L’enregistrement a échoué, réessaie',
  'pruvodce.kroku': 'étapes',
  'pruvodce.odborniku': (p) => `${p.pocet === 1 ? 'professionnel·le' : 'professionnel·les'} pour cette étape`,
  'pruvodce.pribehu': (p) => `${p.pocet === 1 ? 'témoignage' : 'témoignages'} de personnes à cette étape`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Réinitialisation du mot de passe',
  'reset.popis': 'Saisis un nouveau mot de passe pour ton compte Bloom.',
  'reset.noveHeslo': 'Nouveau mot de passe',
  'reset.noveHesloPriklad': 'Saisis un nouveau mot de passe',
  'reset.potvrdit': 'Confirme le nouveau mot de passe',
  'reset.nastavit': 'Enregistrer le nouveau mot de passe',
  'reset.ukladam': 'Enregistrement…',
  'reset.hotovo': 'Ton mot de passe a été changé. Tu peux te connecter.',
  'reset.neplatnyOdkaz': 'Ce lien de réinitialisation n’est pas valide.',
  'reset.odkazVyprsel': 'Le lien a expiré ou n’est pas valide. Demandes-en un nouveau.',
  'reset.chyba': 'Le mot de passe n’a pas pu être réinitialisé.',
  'reset.neshoda': 'Les mots de passe ne correspondent pas.',
  'reset.ztratiPristup': 'perdra l’accès',

  'cesta.volitelne': 'C’est entièrement facultatif. Partage ton étape de transition si tu veux — ou garde-la pour toi. '
      + 'Tu peux aussi trouver des personnes à un point semblable de leur parcours.',
  'cesta.hledatVeFazi': 'Trouver des personnes à cette étape :',
  'cesta.jenVerejne': '(seulement celles qui la partagent publiquement)',
  'pruvodce.zpetNaCestu': 'Retour à Mon parcours',
  'pruvodce.tadyJsi': 'Tu en es là',
  'reset.prejitNaPrihlaseni': 'Aller à la connexion',
  'reset.sifrovaniVarovani': 'Si le chiffrement de tes messages est activé : réinitialiser ton mot de passe veut dire que tu n’atteindras plus tes anciens '
      + 'messages chiffrés. Leur clé s’ouvre avec le mot de passe d’origine, que personne ici ne connaît : elle ne peut donc pas '
      + 'être ré-enveloppée. Les nouveaux messages pourront encore être chiffrés ; les anciens ne seront plus lisibles — par nous non plus.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Se connecter',
  'uvod.vytvoritUcet': 'Créer un compte',
  'uvod.uzMamUcet': 'J’ai déjà un compte',
  'uvod.nadpis': 'Un espace sûr pour la communauté trans',
  'uvod.podnadpis': 'Bloom est un endroit privé où tu peux parler librement, trouver des professionnel·les trans-friendly '
      + 'et vivre ta transition parmi des gens qui savent ce que c’est.',
  'uvod.zdarma': 'L’inscription est gratuite. Le contenu de Bloom ne s’ouvre qu’une fois connecté·e.',
  'uvod.kCemuJe': 'À quoi sert Bloom',
  'uvod.kCemuJe1': 'Chercher des informations sur la transition en Tchéquie, c’est souvent cliquer à travers des forums '
      + 'éparpillés, des articles périmés et des liens dont on ne sait pas s’il faut leur faire confiance. Et à beaucoup de questions, '
      + 'c’est quelqu’un qui est passé par là qui répond le mieux.',
  'uvod.kCemuJe2': 'Bloom rassemble tout au même endroit : des professionnel·les dont la communauté a une bonne expérience, un guide '
      + 'des étapes de la transition, de l’aide juridique et surtout des gens à qui écrire.',
  'uvod.kCemuJe3': 'Et parce qu’il s’agit de choses que personne n’a envie de raconter à tout internet, Bloom est construit dès '
      + 'le départ pour que rien du tout ne soit visible de l’extérieur.',
  'uvod.coNajdes': 'Ce que tu trouveras dans Bloom',
  'uvod.coNajdesPopis': 'Huit parties qui se répondent — de l’aide pratique aux expériences partagées.',
  'uvod.soukromiZaklad': 'La confidentialité n’est pas une option, c’est la base',
  'uvod.jakZabezpeceny': 'Comment Bloom est sécurisé',
  'uvod.zabezpeceniPopis': 'Les données des membres ne sont ni vendues ni analysées. Aucun pistage publicitaire ni statistique '
      + 'ne tourne dans Bloom — aucun script tiers n’apprend quoi que ce soit sur toi.',
  'uvod.coNeumi': 'Ce que Bloom ne sait pas faire',
  'uvod.metadataTucne': 'qui écrit à qui et quand',
  'uvod.coNeumiA': 'Le serveur sait toujours',
  'uvod.coNeumiB': ' — sans ça, il ne pourrait pas livrer le message. Le chiffrement de bout en bout ne cache pas ces '
      + 'métadonnées, et Signal non plus. Les profils ne peuvent pas être chiffrés, parce que le serveur doit les montrer '
      + 'aux autres. Et comme Bloom est une application web, elle télécharge son code de chiffrement depuis notre serveur '
      + 'à chaque ouverture — qui prendrait le contrôle du serveur pourrait en théorie en servir un modifié. '
      + 'Seule une application signée venant d’un magasin protège de cela.',
  'uvod.pridejSe': 'Rejoins-nous',
  'uvod.pridejSePopis': 'Un pseudo et une adresse e-mail suffisent — tu n’as jamais à donner ton prénom d’état civil. Ce que tu écris '
      + 'sur toi ne dépend que de toi, et tu peux le changer ou l’effacer quand tu veux.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Propose de l’aide ou demandes-en : accompagner à un rendez-vous, prêter des vêtements, ou simplement '
      + '« j’ai besoin de parler à quelqu’un ».',
  'uvod.karta.odbornici': 'Sexologie, endocrinologie, chirurgie, psychothérapie et même coiffure. Avec une carte, des contacts et les retours des autres.',
  'uvod.karta.pravo': 'Changement de prénom, papiers officiels, travail, études. Réponses par des gens qui connaissent le terrain.',
  'uvod.karta.pruvodce': 'Ce qui t’attend à chaque étape — des premières questions aux opérations. Avec des liens vers des sources vérifiées et des professionnel·les.',
  'uvod.karta.zpravy': 'Écris à qui tu veux dans la communauté. Les messages et les pièces jointes sont stockés chiffrés sur le serveur.',
  'uvod.karta.zkusenosti': 'De vrais récits de gens qui sont passés par là. Sans censure et sans enjoliver.',
  'uvod.karta.aktuality': 'Ce qui se passe autour des sujets trans en Tchéquie — changements de loi, événements, nouvelles de la communauté.',
  'uvod.karta.okoli': 'Qui est près de toi. Pour que tu saches que tu n’es pas seul·e, même dans une petite ville.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'De l’extérieur, rien n’est visible',
  'uvod.bezp.zvencinicText': 'Les profils, les récits, les photos, les offres et les images des publications demandent d’être connecté·e. Sans compte, le '
      + 'serveur ne livre aucune information sur les membres — pas même aux moteurs de recherche.',
  'uvod.bezp.hesla': 'Personne ne connaît ton mot de passe',
  'uvod.bezp.heslaText': 'Seule une empreinte bcrypt est conservée, et le mot de passe d’origine ne peut pas en être recalculé. Même '
      + 'l’administration ne voit pas ton mot de passe et ne peut pas te l’envoyer — elle peut seulement te laisser en choisir un nouveau.',
  'uvod.bezp.sifrovani': 'Des messages chiffrés de toi à l’autre personne',
  'uvod.bezp.sifrovaniText': 'Quand tu actives le chiffrement de bout en bout, le texte et les pièces jointes sont chiffrés dans ton propre navigateur. '
      + 'La clé s’ouvre avec ton mot de passe et ne quitte jamais ton appareil — le serveur ne reçoit que '
      + 'des caractères illisibles et ne peut pas les lire, même si un tribunal le demandait. Sans chiffrement, les messages sont au moins '
      + 'chiffrés sur le disque du serveur.',
  'uvod.bezp.kontakty': 'Tes coordonnées restent les tiennes',
  'uvod.bezp.kontaktyText': 'Ton e-mail et ton téléphone ne sont jamais transmis aux autres membres. Ton étape de transition est privée tant '
      + 'que tu ne la publies pas — et les étapes que tu coches dans le Guide, toi seul·e les vois.',
  'uvod.bezp.smazane': 'Supprimé veut vraiment dire supprimé',
  'uvod.bezp.smazaneText': 'Tu peux supprimer une conversation quand tu veux. Une fois que les deux personnes l’ont supprimée, elle disparaît du serveur '
      + 'définitivement, pièces jointes comprises.',
  'uvod.bezp.server': 'Notre propre serveur en Europe',
  'uvod.bezp.serverText': 'Bloom tourne sur son propre serveur dans l’Union européenne, uniquement en HTTPS. La base de données n’est pas joignable '
      + 'depuis internet. Les sauvegardes partent chiffrées vers un autre stockage et leur restauration a été testée.',

  'uvod.karta.pruvodceNazev': 'Guide de la transition',
  'uvod.karta.zpravyNazev': 'Messages privés',

  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Propose ce que tu sais faire et reçois l’aide des autres membres',
  'pod.vse': 'Tout',
  'pod.nabidky': 'Offres',
  'pod.poptavky': 'Demandes',
  'pod.nabidka': 'Offre',
  'pod.poptavka': 'Demande',
  'pod.celaCR': 'Toute la Tchéquie',
  'pod.celySvet': 'Le monde entier',
  'pod.cesko': 'Tchéquie',
  'pod.svet': 'Monde',
  'pod.vsechnyTypy': 'Toutes les catégories',
  'pod.moje': (p) => `Les miennes (${p.pocet})`,
  'pod.pridat': 'Ajouter',
  'pod.overEmail': 'Vérifie ton e-mail pour pouvoir ajouter une offre',
  'pod.novaPoptavka': 'Nouvelle demande',
  'pod.novaNabidka': 'Nouvelle offre',
  'pod.popisPoptavky': 'Écris ce que tu cherches et ce que tu proposes en échange.',
  'pod.popisNabidky': 'Propose ce que tu sais faire aux autres membres de la communauté.',
  'pod.typPrispevku': 'Type de publication',
  'pod.volitelne': '(facultatif)',
  'pod.coNabizim': 'Ce que je propose',
  'pod.coNabizimP': 'Ce que je propose *',
  'pod.coHledamP': 'Ce que je cherche *',
  'pod.coHledamVymenou': 'Ce que je cherche en échange',
  'pod.priklOffer': 'p. ex. cuisine, coiffure, traduction…',
  'pod.priklNeed': 'p. ex. massages, photographie…',
  'pod.poptavkaSeZobrazi': 'Ta demande apparaîtra dans l’onglet Demandes.',
  'pod.nabidkaSeZobrazi': 'Si tu remplis ce champ, ton offre apparaîtra aussi dans l’onglet Demandes.',
  'pod.popis': 'Description',
  'pod.popisPriklad': 'Une description plus détaillée…',
  'pod.oblast': 'Zone',
  'pod.lokalita': 'Lieu',
  'pod.nechciUvadet': 'Je préfère ne pas le dire',
  'pod.kategorie': 'Catégorie',
  'pod.ostatni': 'Autre',
  'pod.pridatPoptavku': 'Ajouter la demande',
  'pod.pridatNabidku': 'Ajouter l’offre',
  'pod.odpovedetNaPrispevek': 'Répondre à la publication',
  'pod.napisteAutorovi': 'Écris un message privé à la personne qui l’a publiée.',
  'pod.od': (p) => `De : ${p.kdo}`,
  'pod.odeslatZpravu': 'Envoyer le message',
  'pod.konceptOdpovedi': (p) => `Bonjour ! Ton ${p.co} « ${p.nazev} » m’intéresse. `,
  'pod.konceptPoptavka': 'annonce',
  'pod.konceptNabidka': 'offre',
  'pod.zadneMoje': 'Tu n’as pas encore de publications',
  'pod.zadneNalezeny': 'Aucune publication trouvée',
  'pod.vytvortePrvni': 'Crée ta première offre ou demande',
  'pod.zkusteFiltry': 'Essaie de changer les filtres ou ajoute une nouvelle publication',
  'pod.expirovano': 'Expirée',
  'pod.hledam': 'Je cherche',
  'pod.hledamCo': (p) => `Je cherche : ${p.co}`,
  'pod.nabizimCo': (p) => `Je propose : ${p.co}`,
  'pod.expirovala': 'Cette offre a expiré. Écris à l’administration pour la renouveler.',
  'pod.odpovedet': 'Répondre',
  'pod.upravitPrispevek': 'Modifier la publication',
  'pod.upravtePrispevek': 'Modifie ton offre ou ta demande.',
  'pod.nabizimP': 'Je propose *',
  'pod.hledamPotrebuji': 'Je cherche / j’ai besoin de',
  'pod.coNabizitePriklad': 'Ce que tu proposes…',
  'pod.coHledatePriklad': 'Ce que tu cherches…',
  'pod.ulozitZmeny': 'Enregistrer les modifications',
  'pod.vytvorenoPoptavka': 'Demande créée.',
  'pod.vytvorenoNabidka': 'Offre créée.',
  'pod.chybaVytvorit': 'La publication n’a pas pu être créée',
  'pod.opravduSmazat': 'Supprimer cette offre ?',
  'pod.smazano': 'Supprimé',
  'pod.chybaSmazat': 'La suppression a échoué',
  'pod.aktualizovano': 'Publication mise à jour.',
  'pod.chybaUlozit': 'L’enregistrement a échoué',
  'pod.zpravaOdeslana': 'Message envoyé.',
  'pod.chybaOdeslat': 'Le message n’a pas pu être envoyé',
  'obecne.hledatPriklad': 'Rechercher…',
  'obecne.upravit': 'Modifier',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Trouve des professionnel·les vérifié·es qui peuvent t’aider sur ton chemin',
  'odb.hledatPriklad': 'Chercher par nom ou par ville…',
  'odb.vsechnyObory': 'Toutes les spécialités',
  'odb.radit': 'Trier :',
  'odb.vychozi': 'Par défaut',
  'odb.nejvyssiHodnoceni': '★ Les mieux noté·es',
  'odb.nejnizsiHodnoceni': '★ Les moins bien noté·es',
  'odb.zadniNalezeni': 'Aucun·e professionnel·le trouvé·e',
  'odb.zkusteFiltry': 'Essaie de changer les filtres',
  'odb.recenzi': (p) => (p.pocet === 1 ? 'avis' : 'avis'),
  'odb.dostupnyV': 'Disponible à :',
  'odb.otevritVMapach': 'Ouvrir dans la carte',
  'odb.pridatRecenzi': 'Ajouter un avis',
  'odb.ohodnotte': 'Donne ton avis sur ton expérience avec cette personne.',
  'odb.vaseHodnoceni': 'Ta note *',
  'odb.popisZkusenosti': 'Décris ton expérience',
  'odb.popisteZkusenost': 'Décris ton expérience…',
  'odb.odeslatRecenzi': 'Envoyer l’avis',
  'odb.recenze': (p) => `Avis (${p.pocet})`,
  'odb.zadneRecenze': 'Pas encore d’avis. Sois la première personne.',
  'odb.vyberteOdbornika': 'Choisis un·e professionnel·le pour voir ses informations et la carte',
  'odb.pridatOdbornika': 'Ajouter un·e professionnel·le',
  'odb.pridejteOdbornika': 'Ajoute à la liste un·e nouveau·elle professionnel·le vérifié·e.',
  'odb.navrhnout': 'Proposer un·e professionnel·le',
  'odb.navrhnetePopis': 'Propose un·e professionnel·le à l’approbation de l’administration.',
  'odb.navrhVysvetleni': 'Ta suggestion sera envoyée à l’administration. Une fois approuvée, elle apparaîtra dans la liste.',
  'odb.overEmail': 'Vérifie ton e-mail pour proposer un·e professionnel·le',
  'odb.jmeno': 'Nom *',
  'odb.kategorie': 'Catégorie *',
  'odb.popis': 'Description',
  'odb.popisPriklad': 'Spécialité, expérience…',
  'odb.adresa': 'Adresse *',
  'odb.mesto': 'Ville *',
  'odb.kraj': 'Région',
  'odb.vyber': 'Choisis',
  'odb.stat': 'Pays',
  'odb.cesko': 'Tchéquie',
  'odb.telefon': 'Téléphone',
  'odb.web': 'Site web',
  'odb.odesilam': 'Envoi…',
  'odb.odeslatKeSchvaleni': 'Envoyer pour approbation',
  'odb.recenzePridana': 'Avis ajouté.',
  'odb.chybaRecenze': 'L’avis n’a pas pu être ajouté',
  'odb.odeslanKeSchvaleni': 'La proposition a été envoyée pour approbation.',
  'odb.chybaOdeslat': 'L’envoi a échoué',
  'odb.pridan': 'Professionnel·le ajouté·e.',
  'odb.chybaPridat': 'L’ajout a échoué',
  'odb.polozitOtazku': 'Poser une question',
  'odb.novaOtazka': 'Nouvelle question aux professionnel·les',
  'odb.naCoSeZeptat': 'Que veux-tu demander aux professionnel·les ?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Informations et soutien pour la communauté trans',
  'prav.zpetNaPoradnu': 'Retour à Aide juridique',
  'prav.clankyAPruvodci': 'Articles et guides',
  'prav.pridatClanek': 'Ajouter un article',
  'prav.novyClanek': 'Nouvel article',
  'prav.vytvorteClanek': 'Écris un nouvel article pour la partie juridique.',
  'prav.nazev': 'Titre *',
  'prav.kategorie': 'Catégorie',
  'prav.publikovatIhned': 'Publier tout de suite',
  'prav.publikovano': 'Publié',
  'prav.obsah': 'Contenu *',
  'prav.obsahPriklad': 'Contenu de l’article…',
  'prav.zadneClanky': 'Aucun article dans cette catégorie',
  'prav.skryto': 'Masqué',
  'prav.skryt': 'Masquer',
  'prav.publikovat': 'Publier',
  'prav.upravitClanek': 'Modifier l’article',
  'prav.upravteObsah': 'Modifie le contenu de cet article.',
  'prav.clanekPridan': 'Article ajouté.',
  'prav.chybaPridat': 'L’article n’a pas pu être ajouté',
  'prav.clanekUpraven': 'Article mis à jour.',
  'prav.opravduSmazat': 'Supprimer cet article ?',
  'prav.chybaStav': 'Le statut n’a pas pu être changé',
  'prav.pridatOtazku': 'Ajouter une question',
  'prav.novaOtazka': 'Nouvelle question',
  'prav.naCoSeZeptat': 'Que veux-tu demander ?',
  'obecne.vse': 'Tout',
  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Des nouvelles du monde trans',
  'akt.prehratVideo': 'Lire la vidéo',
  'akt.obrazekVClanku': 'Image de l’article',
  'akt.clanekNenalezen': 'Article introuvable',
  'akt.zpetNaAktuality': 'Retour aux actualités',
  'akt.autor': (p) => `Autrice ou auteur : ${p.kdo}`,
  'akt.osobniPribeh': 'Récit personnel',
  'akt.upravitClanek': 'Modifier l’article',
  'akt.komentare': (p) => `Commentaires (${p.pocet})`,
  'akt.zadneKomentare': 'Pas encore de commentaires. Sois la première personne.',
  'akt.pridatKomentar': 'Ajouter un commentaire…',
  'akt.proKomentovaniOverte': 'Vérifie ton e-mail pour commenter.',
  'akt.profil': 'Profil',
  'akt.prihlasteSeProKomentovani': 'Connecte-toi pour commenter.',
  'akt.upravteObsah': 'Modifie le contenu de cet article.',
  'akt.nadpisP': 'Titre *',
  'akt.nadpis': 'Titre',
  'akt.obsahP': 'Contenu *',
  'akt.textClanku': 'Texte de l’article…',
  'akt.obrazekUrlNeboSoubor': 'Image (adresse ou fichier)',
  'akt.videoUrlNeboSoubor': 'Vidéo (adresse ou fichier)',
  'akt.ukladam': 'Enregistrement…',
  'akt.novaAktualita': 'Nouvel article',
  'akt.sdiletPribeh': 'Partager un récit',
  'akt.vytvoritAktualitu': 'Écrire un article',
  'akt.sdiletZkusenost': 'Partager une expérience',
  'akt.napisteAktualitu': 'Écris un nouvel article pour la communauté.',
  'akt.podelteSe': 'Partage ton expérience avec la communauté.',
  'akt.obrazek': 'Image',
  'akt.nahratObrazek': 'Envoyer une image…',
  'akt.nahratVideo': 'Envoyer une vidéo…',
  'akt.neboUrl': 'ou une adresse :',
  'akt.textAktuality': 'Texte de l’article…',
  'akt.sdilejtePribeh': 'Partage ton histoire ou ton expérience avec la communauté…',
  'akt.nahravam': 'Envoi…',
  'akt.publikovat': 'Publier',
  'akt.zkusenostiTucne': 'Expériences personnelles des membres.',
  'akt.zkusenostiPopis': 'Cette partie sert à partager des expériences et des récits de vie. Les publications peuvent contenir du texte, des images ou de la vidéo.',
  'akt.sdiletSvujPribeh': 'Partager mon récit',
  'akt.zadneAktuality': 'Pas d’actualités',
  'akt.zadneVKategorii': 'Il n’y a encore rien dans cette catégorie',
  'akt.publikovan': 'Publication publiée.',
  'akt.chybaPublikovat': 'La publication a échoué',
  'akt.opravduSmazat': 'Supprimer cette publication ?',
  'akt.chyba': 'Quelque chose a mal tourné',
  'akt.chybaKomentar': 'Le commentaire n’a pas pu être ajouté',
  'akt.chybaSmazatKomentar': 'Le commentaire n’a pas pu être supprimé',
  'akt.aktualizovan': 'Publication mise à jour.',
  'obecne.smazat': 'Supprimer',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'J’envisage une transition',
  'faze.thinking.popis': 'Je cherche qui je suis et quel chemin est le mien.',
  'faze.research': 'Je cherche des informations',
  'faze.research.popis': 'Je lis, je pose des questions, je cherche des sources et une communauté.',
  'faze.therapist': 'Première consultation',
  'faze.therapist.popis': 'Je parle de mon parcours avec un·e professionnel·le.',
  'faze.hormones': 'Traitement hormonal',
  'faze.hormones.popis': 'Je commence ou je poursuis un traitement hormonal.',
  'faze.documents': 'Changement d’état civil',
  'faze.documents.popis': 'Je travaille au changement légal de prénom ou de mention de sexe.',
  'faze.cosmetic': 'Apparence et soins',
  'faze.cosmetic.popis': 'Je travaille mon apparence – cheveux, maquillage, style.',
  'faze.surgery-thinking': 'J’envisage une opération',
  'faze.surgery-thinking.popis': 'Je réfléchis aux possibilités chirurgicales.',
  'faze.surgery': 'Après les opérations',
  'faze.surgery.popis': 'J’ai eu une ou plusieurs opérations.',
  'faze.stable': 'Étape stable',
  'faze.stable.popis': 'Je suis là où je veux être et je vis ma vie.',
  'faze.individual': 'Mon propre chemin',
  'faze.individual.popis': 'Mon chemin n’entre dans aucune case – et c’est très bien.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'C’est ici qu’on partage les récits.',
  'zk.pribehNenalezen': 'Récit introuvable',
  'zk.zpetNaPribehy': 'Retour aux récits',
  'zk.komunita': 'La communauté',
  'zk.pribeh': 'Récit',
  'zk.upravitPribeh': 'Modifier le récit',
  'zk.upravtePribeh': 'Modifie le récit que tu as partagé.',
  'zk.textPribehu': 'Texte du récit…',
  'zk.fazeTranzice': 'Étape de la transition',
  'zk.neuvadet': 'Ne pas préciser',
  'zk.ukazeSeLidem': 'Le récit sera montré aux personnes qui lisent le guide de cette étape.',
  'zk.sdiletPribeh': 'Partager un récit',
  'zk.overEmail': 'Vérifie ton e-mail pour partager un récit',
  'zk.zadnePribehy': 'Pas encore de récits. Sois la première personne.',
  'zk.nazevPribehu': 'Le titre de ton récit…',
  'zk.pribehP': 'Récit *',
  'zk.sdilejteZkusenost': 'Partage ton expérience avec la communauté…',
  'zk.chybaNacist': 'Les récits n’ont pas pu être chargés',
  'zk.vyplnteNadpis': 'Remplis le titre et le texte',
  'zk.spatnyOdkaz': 'Le lien vers l’image doit commencer par http://, https:// ou /',
  'zk.sdilen': 'Récit partagé.',
  'zk.chybaSdilet': 'Le partage a échoué',
  'zk.opravduSmazat': 'Supprimer ce récit ?',
  'zk.smazan': 'Récit supprimé',
  'zk.aktualizovan': 'Récit mis à jour.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Ton e-mail n’est pas encore vérifié. Confirme-le, s’il te plaît.',
  'ram.odesilam': 'Envoi…',
  'ram.znovuOdeslat': 'Renvoyer',
  'ram.chceteUpozorneni': 'Veux-tu être averti·e des nouveaux messages ?',
  'ram.tedNe': 'Pas maintenant',
  'ram.paticka': '© 2026 Bloom – un espace privé pour la communauté trans',
  'ram.zasadyKomunity': 'Règles de la communauté',
  'ram.nahlasitProblem': 'Signaler un problème',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Administration',
  'ot.overenyPravnik': 'Juriste vérifié·e',
  'ot.overenyOdbornik': 'Professionnel·le vérifié·e',
  'ot.odznakJinaZeme': (p) => `Ce badge ne vaut que pour : ${p.zeme}`,
  'ot.otazkyKomunity': 'Questions de la communauté',
  'ot.pridatOtazku': 'Ajouter une question',
  'ot.novaOtazka': 'Nouvelle question',
  'ot.naCoSeZeptat': 'Que veux-tu demander ?',
  'ot.otazkaSeZobrazi': 'Ta question sera montrée aux autres membres, qui pourront y répondre.',
  'ot.otazkaP': 'Question *',
  'ot.oblastTema': 'Domaine / thème',
  'ot.vseObecna': 'N’importe quoi (question générale)',
  'ot.odeslatOtazku': 'Envoyer la question',
  'ot.overEmail': 'Vérifie ton e-mail pour poser une question',
  'ot.zadneOtazky': 'Pas encore de questions. Sois la première personne.',
  'ot.hlasu': (p) => (p.pocet === 1 ? 'voix' : 'voix'),
  'ot.odpovedi': (p) => (p.pocet === 1 ? 'réponse' : 'réponses'),
  'ot.zadneOdpovedi': 'Pas encore de réponses.',
  'ot.napisteOdpoved': 'Écris une réponse…',
  'ot.jenPravnici': 'Aux questions d’Aide juridique répondent des juristes vérifié·es et l’administration.',
  'ot.smazatOtazku': 'Supprimer cette question ?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Offres et demandes',
  'cp.zadneNabidky': 'Aucune offre',
  'cp.napsatZpravu': 'Écrire un message',
  'cp.nahlasitUzivatele': 'Signaler cette personne',
  'cp.nahlasitKoho': (p) => `Signaler ${p.kdo}`,
  'cp.popisteDuvod': 'Explique pourquoi tu la signales. L’administration verra le signalement.',
  'cp.zustaneteAnonymni': 'Le signalement est reçu par l’administration. Tu restes anonyme.',
  'cp.duvodP': 'Motif *',
  'cp.vybertDuvod': 'Choisis un motif…',
  'cp.nevhodneChovani': 'Comportement déplacé',
  'cp.falesnyProfil': 'Faux profil',
  'cp.jinyProblem': 'Autre problème',
  'cp.popisVolitelny': 'Description',
  'cp.volitelny': '(facultatif)',
  'cp.popisteSituaci': 'Décris la situation plus en détail…',
  'cp.odeslatNahlaseni': 'Envoyer le signalement',
  'cp.vyberteDuvodChyba': 'Choisis un motif pour le signalement',
  'cp.nahlaseniOdeslano': 'Le signalement a été envoyé à l’administration',
  'cp.chybaNahlaseni': 'Le signalement n’a pas pu être envoyé',
  'gal.chranenoHeslem': 'Protégée par mot de passe',
  'gal.soukromi': 'Confidentialité',
  'gal.nahravam': 'Envoi…',
  'gal.pridatFotku': 'Ajouter une photo',
  'gal.nastaveniSoukromi': 'Confidentialité de la galerie',
  'gal.verejna': 'Publique',
  'gal.chranenaHeslem': 'Protégée par mot de passe',
  'gal.nastaveniUlozeno': 'Réglages de la galerie enregistrés',
  'gal.jeChranena': 'Cette galerie est protégée par un mot de passe',
  'gal.zadneFotky': 'Pas encore de photos. Ajoute la première.',
  'gal.otagovat': 'Identifier quelqu’un',
  'gal.hledatUzivatele': 'Chercher une personne…',
  'gal.odemcena': 'Galerie déverrouillée',
  'gal.spatneHeslo': 'Mot de passe de la galerie incorrect',
  'gal.fotkaNahrana': 'Photo envoyée.',
  'gal.chybaNahrat': 'La photo n’a pas pu être envoyée',
  'gal.fotkaSmazana': 'Photo supprimée',
  'gal.jizOtagovan': 'Cette personne est déjà identifiée',
  'gal.otagovan': (p) => `Identifiée : ${p.kdo}`,
  'gal.chybaTag': 'L’identification n’a pas pu être ajoutée',

  'ram.povolit': 'Autoriser',
  'ram.oProjektu': 'Le projet',
  'ram.prekladNeovereny': 'Personne qui parle cette langue n’a encore relu cette traduction. Si quelque chose sonne faux, dis-le-nous.',
  'ram.kontakt': 'Contact',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Carte du monde – clique sur un pays pour l’ouvrir',
  'mapa.priblizit': 'Zoomer',
  'mapa.oddalit': 'Dézoomer',
  'mapa.celySvet': 'Revenir au monde entier',
  'mapa.chybaNacteni': 'La carte n’a pas pu être chargée',
  'mapa.chybaZkusteSeznam': 'La carte n’a pas pu être chargée. Essaie la liste des pays ci-dessous.',
  'mapa.teprveRoste': 'Bloom commence tout juste ici',
  'mapa.napovedaDotyk': 'Fais glisser pour déplacer la carte ; pince, double-tape ou utilise les boutons pour zoomer. Tu n’es pas obligé·e de t’en servir : la recherche et la liste complète des pays sont en dessous.',
  'obsah.specialists': (p) => (p.pocet === 1 ? 'professionnel·le' : 'professionnel·les'),
  'obsah.organizations': (p) => (p.pocet === 1 ? 'association' : 'associations'),
  'obsah.events': (p) => (p.pocet === 1 ? 'événement' : 'événements'),
  'obsah.pageants': (p) => (p.pocet === 1 ? 'concours' : 'concours'),
  'obsah.resources': (p) => (p.pocet === 1 ? 'ressource' : 'ressources'),
  'obsah.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entrée' : 'entrées'}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Où est-ce que tu vis ?',
  'domov.popis': 'Bloom te montrera alors ce qui est près de toi. Tu peux parcourir n’importe quel pays — cela ne change pas '
      + 'ton pays de résidence. Ce n’est jamais rendu public et tu peux le changer quand tu veux.',
  'domov.preskocit': 'Passer',
  'domov.najitZemi': 'Trouver un pays…',
  'domov.nicNeodpovida': 'Rien ne correspond. Essaie une autre recherche.',
  'domov.klikniDoMapy': 'Tu peux aussi simplement cliquer sur un pays dans la carte au-dessus.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Publication',
  'typ.users': 'Personne',
  'typ.specialists': 'Professionnel·le',
  'typ.services': 'Offre',
  'typ.articles': 'Aide juridique',
  'typ.questions': 'Question de la communauté',
  'typ.reviews': 'Avis sur un·e professionnel·le',
  'nav.emailNeoveren': 'E-mail non vérifié',
  'nav.neovereny': 'Non vérifié',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Quelque chose ne marche pas',
  'chyba.navrh': 'Une idée d’amélioration',
  'chyba.bezpecnost': 'Un problème de sécurité',
  'chyba.jiny': 'Autre chose',
  'chyba.vyberteTyp': 'Choisis le type de problème',
  'chyba.popisteProsim': 'Décris le problème',
  'chyba.odeslano': 'Signalement envoyé, merci !',
  'chyba.chybaOdeslat': 'Le signalement n’a pas pu être envoyé',
  'chyba.napisteNam': 'Raconte-nous ce qui s’est passé — ça nous aide à le corriger.',
  'chyba.typProblemu': 'Type de problème',
  'chyba.popisProblemu': 'Ce qui s’est passé',
  'chyba.popisPriklad': 'Décris ce qui s’est passé, ce à quoi tu t’attendais et ce qui est arrivé à la place…',
  'chyba.priloha': 'Nous joignons automatiquement : la page en cours, l’heure et des informations sur ton navigateur.',
  'chyba.odeslatHlaseni': 'Envoyer le signalement',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Écris le contenu…',
  'ed.tucne': 'Gras (Ctrl+B)',
  'ed.kurziva': 'Italique (Ctrl+I)',
  'ed.odrazky': 'Liste à puces',
  'ed.vlozitOdkaz': 'Insérer un lien',
  'ed.vlozitTabulku': 'Insérer un tableau',
  'ed.radky': 'Lignes',
  'ed.sloupce': 'Colonnes',
  'ed.vlozit': 'Insérer',
  'ed.barva.cerna': 'Noir',
  'ed.barva.seda': 'Gris',
  'ed.barva.fialova': 'Violet',
  'ed.barva.ruzova': 'Rose',
  'ed.barva.modra': 'Bleu',
  'ed.barva.zelena': 'Vert',
  'ed.barva.cervena': 'Rouge',
  'ed.barva.oranzova': 'Orange',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Ce lien de vérification n’est pas valide.',
  'over.hotovo': 'Ton e-mail est vérifié.',
  'over.odkazVyprsel': 'Le lien de vérification n’est pas valide ou a expiré.',
  'over.overuji': 'Vérification de ton e-mail…',
  'over.cekejte': 'Patiente un instant.',
  'over.overen': 'E-mail vérifié.',
  'over.plnyPristup': 'Tu as maintenant accès à tout Bloom.',
  'over.prejitNaBloom': 'Aller à Bloom',
  'over.selhalo': 'La vérification a échoué',
  'over.zpetNaPrihlaseni': 'Retour à la connexion',
  'oauth.ucetNenalezen': 'Compte introuvable',
  'oauth.neexistujeGoogle': 'Il n’existe pas de compte Bloom pour ce compte Google. Inscris-toi d’abord.',
  'oauth.neexistujeFacebook': 'Il n’existe pas de compte Bloom pour ce compte Facebook. Inscris-toi d’abord.',
  'oauth.registrovatGoogle': 'S’inscrire avec Google',
  'oauth.registrovatFacebook': 'S’inscrire avec Facebook',
  'oauth.prihlasujiGoogle': 'Connexion avec Google…',
  'oauth.prihlasujiFacebook': 'Connexion avec Facebook…',
  'oauth.facebookSelhalo': 'La connexion avec Facebook a échoué',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Chargement…',
  'obecne.nezadano': '— non renseigné —',
  'obecne.neplatnaHodnota': 'Cette valeur n’est pas valide.',
  'obecne.strankovani': 'Pagination',
  'navrh.doplnteNazev': 'Remplis le nom.',
  'navrh.vyberteZemi': 'Choisis un pays.',
  'navrh.doplnte': (p) => `Remplis : ${p.co}.`,
  'kat.overenoZaznam': 'Vérifié que l’entrée correspond à la réalité',
  'kat.prihlaskyDo': (p) => `Inscriptions jusqu’au ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Profil',
  'profil.zalozkaGalerie': 'Galerie',
  'pf.lokalita': 'Lieu',

  'cesta.legendaBarev': 'Légende des couleurs',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${p.pocet === 1 ? 'résultat' : 'résultats'})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Longs cheveux blonds',
  'avatar.fem-lavender': 'Cheveux violets',
  'avatar.fem-peach': 'Carré à frange',
  'avatar.fem-dark': 'Longs cheveux foncés',
  'avatar.fem-straight': 'Cheveux roux',
  'avatar.fem-ponytail': 'Queue-de-cheval',
  'avatar.masc-blue': 'Cheveux blonds courts',
  'avatar.masc-teal': 'Cheveux ébouriffés',
  'avatar.masc-gray': 'Cheveux gris',
  'avatar.masc-short': 'Coupe en brosse',
  'avatar.nb-mint': 'Cheveux vert menthe',
  'avatar.nb-lilac': 'Chignon haut',
  'avatar.nb-curly': 'Boucles courtes',
  'avatar.nb-sage': 'Cheveux mi-longs',
  'avatar.nb-mohawk': 'Crête',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Crâne rasé',
  'avatar.nb-glasses': 'Lunettes',
  'avatar.animal-cat': 'Chat',
  'avatar.animal-fox': 'Renard',
  'avatar.animal-rabbit': 'Lapin',
  'avatar.sym-flower': 'Fleur',
  'avatar.sym-butterfly': 'Papillon',
  'avatar.sym-star': 'Étoile',
  'avatar.custom': 'Envoyer ma propre photo',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Nous t’avons déconnecté·e après un moment d’inactivité.',
  'odhl.necinnostPopis': 'Bloom ne laisse pas la session ouverte quand il n’y a personne.',
  'odhl.zaChvili': 'Nous allons te déconnecter dans un instant',
  'odhl.zaChviliPopis': 'Touche l’écran ou le clavier à tout moment et tu restes connecté·e.',

  'reg.avatarSymboly': 'Symboles',

  'avatar.fem-bun': 'Chignon',
  'avatar.masc-navy': 'Barbe fournie',
  'avatar.masc-brown': 'Raie sur le côté',
  'avatar.masc-goatee': 'Bouc',
  'avatar.nb-freckles': 'Taches de rousseur',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Chouette',
  'avatar.sym-rainbow': 'Arc-en-ciel',
  'avatar.sym-heart': 'Cœur',
  'avatar.sym-lotus': 'Lotus (Bloom)',

  'reg.potvrditHeslo': 'Confirmer le mot de passe',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Créer',
  'obecne.sdilet': 'Partager',
  'obecne.opravneni': 'Autorisation',
  'obecne.pristupGalerie': 'Nous avons besoin d’accéder à vos photos pour envoyer une image.',
  'obecne.vsechnyRegiony': 'Toutes les régions',
  'obecne.cesko': 'Tchéquie',
  'obecne.odbornici': 'Professionnels',
  'obecne.zadnaZprava': 'Aucun message',
  'ucet.vyplnteEmailHeslo': 'Saisis ton e-mail et ton mot de passe',
  'ucet.spatneUdaje': 'E-mail ou mot de passe incorrect',
  'ucet.googleSelhalo': 'La connexion avec Google a échoué',
  'ucet.skrytHeslo': 'Masquer le mot de passe',
  'ucet.emailOveren': 'Ton e-mail a été vérifié.',
  'ucet.emailPriklad': 'vous@email.com',
  'ucet.overeniSelhalo': 'La vérification a échoué.',
  'ucet.overeniSelhaloZnovu': 'La vérification a échoué. Réessaie.',
  'ucet.komunitniHesloPovinne': 'Le mot de passe de la communauté est obligatoire',
  'ucet.zadejteKomunitniHeslo': 'Saisis le mot de passe de la communauté…',
  'ucet.komunitniHesloPopis': 'Bloom est un espace privé. Quelqu’un de la communauté peut te donner le mot de passe.',
  'ucet.prezdivkaMin3': 'Le pseudo doit contenir au moins 3 caractères',
  'ucet.vyplntePrezdivku': 'Saisis un pseudo',
  'ucet.vasePrezdivka': 'Ton pseudo',
  'ucet.profilNeulozen': 'Impossible d’enregistrer le profil',
  'ucet.anoZrusitProfil': 'Oui, supprimer mon profil',
  'heslo.min8': 'Le mot de passe doit contenir au moins 8 caractères',
  'heslo.maleP': 'Le mot de passe doit contenir une minuscule',
  'heslo.velkeP': 'Le mot de passe doit contenir une majuscule',
  'heslo.cislo': 'Le mot de passe doit contenir un chiffre',
  'heslo.specialni': 'Le mot de passe doit contenir un caractère spécial',
  'heslo.specialniPriklad': 'Le mot de passe doit contenir un caractère spécial (!@#$%)',
  'heslo.napoveda': 'Min. 8 caractères, majuscule, chiffre, spécial',
  'profil.oSobe': 'Quelques mots sur toi…',
  'profil.zajmenaOna': 'elle',
  'profil.zajmenaJine': 'autre',
  'profil.doplnujiciText': 'Note complémentaire facultative…',
  'profil.prikladOboru': 'p. ex. chirurgie plastique, droit de la famille…',
  'komunita.soukromiNadpis': 'Nous protégeons la vie privée',
  'komunita.soukromiText': 'Ce qui est partagé dans Bloom reste dans Bloom.',
  'komunita.podporaText': 'Bloom, c’est le soutien mutuel.',
  'komunita.neniObchod': 'Bloom n’est pas une plateforme commerciale.',
  'komunita.zadneObtezovani': 'Le harcèlement, quel qu’il soit, n’a pas sa place dans Bloom.',
  'komunita.oslovovani': 'Nous appelons chacun·e par le prénom et les pronoms qu’iel utilise.',
  'komunita.jakakolivEtapa': 'Où que tu en sois dans ton parcours.',
  'prav.kategZdravi': 'Santé',
  'prav.kategPravni': 'Juridique',
  'prav.kategSocialni': 'Social',
  'ot.chybaOdpoved': 'Impossible d’envoyer la réponse.',
  'ot.chybaOtazka': 'Impossible d’ajouter la question.',
  'zk.napisteKomentar': 'Écris un commentaire…',
  'zpr.chybaHlasova': 'Impossible d’envoyer le message vocal. Serveur :',
  'zpr.chybaObrazek': 'Impossible d’envoyer l’image. Serveur :',
  'pod.nabizim': 'Je propose',
  'pod.coHledate': 'Que cherches-tu ? (p. ex. massage, photographie…)',
  'pod.coNabizite': 'Que proposes-tu ? (p. ex. cuisine, coiffure…)',
  'pod.lokalitaVolitelna': 'Lieu (facultatif)',
  'pod.podrobnejsiPopis': 'Description plus détaillée *',
  'pod.vyplnteHledate': 'Indique ce que tu cherches.',
  'pod.vyplnteNabizite': 'Indique ce que tu proposes.',
  'pod.vyplntePopis': 'Ajoute une description.',
  'pod.zadnePrispevky': 'Tu n’as encore rien publié. Crée une offre ou une demande.',
  'svet.vybratZemi': 'Choisir un pays',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Poser une question',
  'ot.nadpis': 'Questions et réponses',
  'zk.pridat': 'Ajouter un récit',
  'zk.novy': 'Nouveau récit',
  'zk.smazat': 'Supprimer le récit',
  'zk.zadne': 'Pas encore de récits. Sois la première personne à partager.',
  'akt.zadne': 'Pas encore d’actualités.',
  'nav.clanky': 'Articles',
  'ucet.emailOdeslan': 'E-mail envoyé',
  'ucet.komunitniHeslo': 'Mot de passe de la communauté',
  'ucet.nemateUcet': 'Pas encore de compte ? Inscris-toi',
  'ucet.muzetePrihlasit': 'Tu peux maintenant te connecter.',
  'ucet.zapomenutePopis': 'Saisis ton e-mail et nous t’enverrons un lien pour réinitialiser ton mot de passe.',
  'profil.oMneVolitelne': 'À propos de moi (facultatif)',
  'profil.prezdivka': 'Pseudo',
  'profil.telefonVolitelne': 'Téléphone (facultatif)',
  'cesta.poznamkaVolitelna': 'Note personnelle (facultative)',
  'okoli.vyberteLokalitu': 'Choisis un lieu ci-dessus',
  'hled.nadpis': 'Recherche',
  'hled.popis': 'Cherche dans toute l’application : personnes, articles, récits, avis…',
  'hled.min2': 'Saisis au moins 2 caractères pour chercher',
  'pod.vsechnySluzby': 'Tous les services',
  'domu.clenoveKomunity': 'Membres de la communauté',
  'zpr.zadneKonverzaceHledat': 'Pas encore de conversations. Cherche quelqu’un ci-dessus.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'il',
  'reg.zajmenaOni': 'iel',
  'reg.zajmenaOno': 'ol',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Supprimer la photo',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Définis un mot de passe pour la galerie',
  'reg.min3znaky': 'Min. 3 caractères',
  'reg.zopakujteHeslo': 'Répète le mot de passe',
  'hled.vBloom': 'Chercher dans Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Modifier le profil',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Choisir une région',
  'obecne.region': 'Région',
  'gal.heslemChranena': 'Protégée par mot de passe',
  'gal.hesloGalerie': 'Mot de passe de la galerie',
  'reset.nastavitHeslo': 'Définir le mot de passe',
  'reset.hesloObnoveno': 'Mot de passe réinitialisé.',
  'profil.nenalezen': 'Profil introuvable',
  'obecne.nebo': 'ou',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Ouvre ton application de codes et recopie les six chiffres affichés pour Bloom. Tu peux aussi saisir un de tes codes de secours.',
  'auth.sifrovaniNapoveda': 'Si tu as activé le chiffrement des messages sur le site, l’application ne peut pas encore se connecter à ce compte. Utilise bloomapp.cz dans un navigateur.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Afficher le mot de passe',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Supprimer cette photo ?',
  'dvf.zadejteKod': 'Saisis le code de ton application',
  'sif.odemknoutAplikaci': 'Déverrouiller l’application',
  'profil.odeslatZnovu': 'Renvoyer',
};

export default fr;
